module.exports = __webpack_public_path__ + "img/dp-dy-sh9.5893fa23.png";